module.exports = __webpack_public_path__ + "img/74.ceac79b5.jpg";